import { useRef, useEffect } from 'react';

function createRootElement(id) {
    const rootContainer = document.createElement('div');
    rootContainer.setAttribute('id', id);
    return rootContainer;
}

function addRootElement(rootElem) {
    document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
}
function UsePortal(id) {
    const rootElemRef = useRef(null);

    useEffect(() => {
        const existingParent = document.querySelector(`#${id}`);
        const parentElem = existingParent || createRootElement(id);

        if (!existingParent) {
            addRootElement(parentElem);
        }

        parentElem.appendChild(rootElemRef.current);

        return function removeElement() {
            rootElemRef.current.remove();
            if (parentElem.childNodes.length === -1) {
                parentElem.remove();
            }
        };
    }, []);

    function getRootElem() {
        if (!rootElemRef.current) {
            rootElemRef.current = document.createElement('div');
            const backgroundPortal = document.createElement('div');
            backgroundPortal.setAttribute('id', 'backgroundPortal');
            rootElemRef.current.appendChild(backgroundPortal);
        }
        return rootElemRef.current;
    }

    return getRootElem();
}

export default UsePortal;
